import React from 'react';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { IMyResult, IResult } from 'modules/mavzuli-test';

import { Segmented } from 'components';

interface IProps {
  myResults?: IMyResult;
  currentTest?: IResult;
  setSelectedIndex?: React.Dispatch<React.SetStateAction<number>>;
}

const TestsBlock: React.FC<IProps> = ({ myResults, currentTest, setSelectedIndex }) => {
  const t = useTranslations();

  const options =
    myResults?.result?.map((item, index) => ({
      label: item.name,
      value: index.toString()
    })) ?? [];

  const onChange = (value: string) => {
    if (setSelectedIndex) {
      setSelectedIndex(parseInt(value, 10));
    }
  };

  const getTooltipText = (checked?: number, correct?: number) => {
    if (checked === correct) return t('togri_javob');
    if (checked === 0) return t('belgilanmagan');
    return t('notogri_javob');
  };

  return (
    <>
      <Segmented type={myResults?.type} options={options} onChange={onChange} labelPrefix={t('Fan')} />

      {currentTest && (
        <div className="mt-3 grid grid-cols-8 sm:grid-cols-14 gap-2 md:grid-cols-22 lg:grid-cols-14">
          {currentTest?.questions?.map(({ checked, correct, question_id: questionId }, index) => (
            <Tooltip key={questionId} title={getTooltipText(checked, correct)} arrow>
              <div
                className={classNames('flex h-8 w-8 items-center justify-center rounded-full border', {
                  'border-green-500 text-green-500': checked === correct,
                  'border-red-500 text-red-500': checked !== 0 && checked !== correct,
                  'border-gray-400 text-gray-400': checked === 0
                })}
              >
                <span className="font-medium">{index + 1}</span>
              </div>
            </Tooltip>
          ))}
        </div>
      )}
    </>
  );
};

export default TestsBlock;
